import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"fidget-overlay {{this.visibleClass}}\" data-test-fidget-overlay ...attributes>\n  {{yield}}\n</div>")